<template lang="pug">
    .upgrade-modal-overlay(v-if="visible", @click.self="handleClose")
      .upgrade-modal.upgrade-modal-success(v-if="phase === 'success'")
        .upgrade-success-top
          .upgrade-success-left
            .upgrade-success-image-text
              img.upgrade-success-decor(src="./images/s1_bg1.png")
              .upgrade-success-info
                .upgrade-success-title 恭喜完成当前学段
                .upgrade-success-desc 根据你的学习进度与当前年级，系统已为你自动匹配新的学段内容
            .upgrade-success-status
              img.upgrade-success-status-bg(src="./images/s1_bg2.png")
              .upgrade-success-status-content
                .upgrade-success-status-text
                  span 即将切换至：
                  span.status-highlight {{ periodName }}
                  img.upgrade-success-status-arrow(src="./images/s1_bg3.png")
          img.upgrade-success-right-img(src="./images/s1_bg.png")
        .upgrade-success-countdown(@click="handleSwitch")
          | 即将为你自动切换（{{ countdown }}s）
      .upgrade-modal.upgrade-modal-switching(v-else-if="phase === 'switching'")
        .upgrade-switching-header
          img.upgrade-switching-header-img(src="./images/s2_bg1.png")
          .upgrade-switching-text
            .upgrade-switching-title 正在为你切换学段
            .upgrade-switching-desc
              | 根据你的学习进度与当前年级，系统将自动升级
              br
              | 到下一学段，并同步推荐更适合的课程与练习。
        .upgrade-switching-body
            .upgrade-switching-body-inner
                img.upgrade-switching-illustration(src="./images/s2_bg.png")
                .upgrade-switching-features
                    .upgrade-switching-feature
                        img(src="./images/icon_history.png")
                        span 学习内容自动更新
                    .upgrade-switching-feature
                        img(src="./images/icon_match.png")
                        span 练习难度智能匹配
                    .upgrade-switching-feature
                        img(src="./images/icon_update.png")
                        span 历史记录完整保留
            .upgrade-switching-progress
              .upgrade-progress-step(:class="{ completed: currentStep > 1, active: currentStep === 1 }")
                .upgrade-progress-circle-wrap
                  .upgrade-progress-circle
                    template(v-if="currentStep > 1")
                      svg(width='14', height='14', viewBox='0 0 14 14', fill='none')
                        path(d='M3 7L6 10L11 4', stroke='#fff', stroke-width='2', stroke-linecap='round', stroke-linejoin='round')
                    template(v-else) 1
                  svg.upgrade-progress-spinner(v-if="currentStep === 1", width='58', height='58', viewBox='0 0 58 58')
                    circle(cx='29', cy='29', r='26', fill='none', stroke='#2ebd73', stroke-width='3', stroke-dasharray='120', stroke-linecap='round')
                .upgrade-progress-label 学段准备中
              .upgrade-progress-line(:class="{ active: currentStep > 1 }")
              .upgrade-progress-step(:class="{ completed: currentStep > 2, active: currentStep === 2 }")
                .upgrade-progress-circle-wrap
                  .upgrade-progress-circle
                    template(v-if="currentStep > 2")
                      svg(width='14', height='14', viewBox='0 0 14 14', fill='none')
                        path(d='M3 7L6 10L11 4', stroke='#fff', stroke-width='2', stroke-linecap='round', stroke-linejoin='round')
                    template(v-else) 2
                  svg.upgrade-progress-spinner(v-if="currentStep === 2", width='58', height='58', viewBox='0 0 58 58')
                    circle(cx='29', cy='29', r='26', fill='none', stroke='#2ebd73', stroke-width='3', stroke-dasharray='120', stroke-linecap='round')
                .upgrade-progress-label 内容升级中
              .upgrade-progress-line(:class="{ active: currentStep > 2 }")
              .upgrade-progress-step(:class="{ completed: currentStep > 3, active: currentStep === 3 }")
                .upgrade-progress-circle-wrap
                  .upgrade-progress-circle
                    template(v-if="currentStep > 3")
                      svg(width='14', height='14', viewBox='0 0 14 14', fill='none')
                        path(d='M3 7L6 10L11 4', stroke='#fff', stroke-width='2', stroke-linecap='round', stroke-linejoin='round')
                    template(v-else) 3
                  svg.upgrade-progress-spinner(v-if="currentStep === 3", width='58', height='58', viewBox='0 0 58 58')
                    circle(cx='29', cy='29', r='26', fill='none', stroke='#2ebd73', stroke-width='3', stroke-dasharray='120', stroke-linecap='round')
                .upgrade-progress-label 推荐匹配中
        //- img.upgrade-switching-bottom(src="./images/bg6.png")
      .upgrade-modal.upgrade-modal-thanks(v-else-if="phase === 'thanks'")
        .upgrade-thanks-top
            div
                .upgrade-thanks-left
                    .upgrade-thanks-icon
                        img(src="./images/bg2.png")
                    .upgrade-thanks-info
                        .upgrade-thanks-title
                            span.thanks-green 感谢
                            | 一路陪伴
                        .upgrade-thanks-desc
                            | 你已完成高中阶段学习。当前暂无
                            br
                            | 大学阶段资源，已购内容和学习记
                            br
                            | 录会为你保留，可随时回来继续使用。
                .upgrade-thanks-tip-bar
                    i.upgrade-thanks-tip-icon.el-icon-time
                    .upgrade-thanks-tip-text
                        span 购置资源和学习记录将暂存
                        img(src="./images/bg3.png")
            .upgrade-thanks-right-img
                img(src="./images/bg.png")
        .upgrade-thanks-btn(@click="handleConfirm")
          span 我知道了
</template>

<script>
import { upgradeToFreeRegister } from '@/api/index'

export default {
    name: 'UpgradeModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        phase: {
            type: String,
            default: 'success' // 'success' | 'switching' | 'thanks'
        },
        periodName: {
            type: String,
            default: '高中学段'
        }
    },
    data() {
        return {
            countdown: 10,
            timer: null,
            currentStep: 1,
            stepTimer: null,
            pollingTimer: null,
            graduateRequestDone: false
        }
    },
    watch: {
        visible(val) {
            if (val && this.phase === 'success') {
                this.countdown = 10
                this.startCountdown()
            } else if (val && this.phase === 'switching') {
                this.currentStep = 1
                this.startStepAnimation()
            } else {
                this.clearAllTimers()
            }
        },
        phase(val) {
            if (this.visible && val === 'switching') {
                this.currentStep = 1
                this.startStepAnimation()
            }
        }
    },
    mounted() {
        if (this.visible && this.phase === 'success') {
            this.countdown = 10
            this.startCountdown()
        } else if (this.visible && this.phase === 'switching') {
            this.currentStep = 1
            this.startStepAnimation()
        }
    },
    beforeDestroy() {
        this.clearAllTimers()
    },
    methods: {
        startCountdown() {
            this.clearTimer()
            this.timer = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--
                } else {
                    this.clearTimer()
                    this.$emit('update:phase', 'switching')
                }
            }, 1000)
        },
        async startStepAnimation() {
            this.clearStepTimers()
            this.graduateRequestDone = false
            this.requestGraduate()

            this.currentStep = 1
            await this.delay(3000)

            this.currentStep = 2
            await this.delay(3000)

            this.currentStep = 3
            await this.delay(3000)

            // 第三步结束，监听接口完成
            if (!this.graduateRequestDone) {
                const unwatch = this.$watch('graduateRequestDone', val => {
                    if (val) {
                        unwatch()
                        this.$emit('complete')
                    }
                })
            } else {
                this.$emit('complete')
            }
        },
        delay(ms) {
            return new Promise(resolve => {
                this.stepTimer = setTimeout(resolve, ms)
            })
        },
        requestGraduate() {
            upgradeToFreeRegister().then(res => {
                if (res.status === 1) {
                    this.graduateRequestDone = true
                }
            }).catch(() => { })
        },
        clearTimer() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        },
        clearStepTimers() {
            if (this.stepTimer) {
                clearTimeout(this.stepTimer)
                this.stepTimer = null
            }
            if (this.pollingTimer) {
                clearTimeout(this.pollingTimer)
                this.pollingTimer = null
            }
        },
        clearAllTimers() {
            this.clearTimer()
            this.clearStepTimers()
        },
        handleSwitch() {
            this.clearTimer()
            this.$emit('update:phase', 'switching')
        },
        handleConfirm() {
            this.visible = false
            upgradeToFreeRegister()
        },
        handleClose() {
            // 不允许点击遮罩关闭
        }
    }
}
</script>

<style lang="less" scoped>
.upgrade-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.upgrade-modal {
    background: #fff;
    border-radius: 24px;
    overflow: hidden;
    display: flex;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

// ====== Phase 1: 成功弹窗 ======
.upgrade-modal-success {
    flex-direction: column;
    width: 892px;
    height: 435px;
    padding: 0;
    border-radius: 30px;
}

.upgrade-success-top {
    display: flex;
    width: 870px;
    height: 328px;
    margin: 2px 0 0 22px;
}

.upgrade-success-left {
    width: 558px;
    height: 252px;
    margin-top: 37px;
}

.upgrade-success-image-text {
    display: flex;
    width: 558px;
    height: 154px;
}

.upgrade-success-decor {
    width: 171px;
    height: 154px;
    flex-shrink: 0;
}

.upgrade-success-info {
    width: 380px;
    margin-top: 5px;
    margin-left: 7px;
}

.upgrade-success-title {
    width: 288px;
    height: 36px;
    color: #2ebd73;
    font-size: 36px;
    font-family: MicrosoftYaHei-Bold, 'Microsoft YaHei', sans-serif;
    font-weight: 700;
    white-space: nowrap;
    line-height: 36px;
}

.upgrade-success-desc {
    width: 380px;
    color: #666;
    font-size: 20px;
    font-family: MicrosoftYaHei, 'Microsoft YaHei', sans-serif;
    line-height: 36px;
    margin-top: 25px;
}

.upgrade-success-status {
    position: relative;
    margin: 8px 0 0 35px;
    width: 403px;
    height: 90px;
    background: linear-gradient(120deg, #ECFFF2, #EFFFE9);
    border-radius: 45px;
    display: flex;
    align-items: center;
    gap: 16px;
}

.upgrade-success-status-bg {
    margin-left: 20px;
}

.upgrade-success-status-content {
    display: flex;
    align-items: center;
    gap: 8px;
}

.upgrade-success-status-icon {
    width: 46px;
    height: 35px;
}

.upgrade-success-status-text {
    display: flex;
    align-items: center;
    gap: 0;
    font-size: 24px;
    line-height: 36px;

    span {
        color: #666;
        font-size: 24px;

    }

    .status-highlight {
        color: #14b964;
        font-size: 24px;
    }
}

.upgrade-success-status-arrow {
    position: absolute;
    right: 22px;
    top: 18px;
    width: 36px;
    height: 39px;
}

.upgrade-success-right-img {
    width: 289px;
    height: 328px;
    flex-shrink: 0;
    object-fit: contain;
}

.upgrade-success-countdown {
    background-color: #ecfbee;
    border-radius: 35px;
    height: 70px;
    width: 768px;
    margin: 0 0 35px 63px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-family: MicrosoftYaHei, 'Microsoft YaHei', sans-serif;
    color: #2ebd73;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #dcfce7;
    }
}

// ====== Phase 2: 切换中弹窗 ======
.upgrade-modal-switching {
    flex-direction: column;
    width: 892px;
    height: 585px;
    padding: 0;
    border-radius: 30px;
    overflow: hidden;
    position: relative;
}

.upgrade-switching-header {
    display: flex;
    width: 583px;
    height: 118px;
    margin: 44px 0 0 37px;
}

.upgrade-switching-header-img {
    width: 145px;
    height: 109px;
    flex-shrink: 0;
    margin-top: 2px;
}

.upgrade-switching-text {
    width: 420px;
    margin-left: 18px;
}

.upgrade-switching-title {
    font-size: 36px;
    font-weight: 700;
    font-family: MicrosoftYaHei-Bold, 'Microsoft YaHei', sans-serif;
    color: #2ebd73;
    line-height: 36px;
}

.upgrade-switching-desc {
    color: #666;
    font-size: 20px;
    font-family: MicrosoftYaHei, 'Microsoft YaHei', sans-serif;
    line-height: 36px;
    margin-top: 25px;
}

.upgrade-switching-body {
    margin: 10px 0 0 1px;
}

.upgrade-switching-body-inner {
    display: flex;
    width: 100%;
    align-items: center;
}

.upgrade-switching-illustration {
    width: 443px;
    height: 296px;
    flex-shrink: 0;
    object-fit: contain;
}

// ====== 进度条 ======
.upgrade-switching-progress {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 0 10px;
    width: 70%;
    margin: 0 auto;
}

.upgrade-progress-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
}

.upgrade-progress-circle-wrap {
    position: relative;
    width: 58px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
}

.upgrade-progress-circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #e5e7eb;
    color: #9ca3af;
    font-size: 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
}

.upgrade-progress-spinner {
    position: absolute;
    top: 0;
    left: 0;
    width: 58px;
    height: 58px;
    animation: spinner-rotate 1s linear infinite;
}

@keyframes spinner-rotate {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.upgrade-progress-label {
    font-size: 12px;
    color: #9ca3af;
    white-space: nowrap;
}

.upgrade-progress-step.completed .upgrade-progress-circle {
    background: #2ebd73;
    color: #fff;
}

.upgrade-progress-step.completed .upgrade-progress-label {
    color: #2ebd73;
}

.upgrade-progress-step.active .upgrade-progress-circle {
    background: #2ebd73;
    color: #fff;
}

.upgrade-progress-step.active .upgrade-progress-label {
    color: #2ebd73;
    font-weight: 500;
}

.upgrade-progress-line {
    flex: 1;
    height: 10px;
    background: #e5e7eb;
    margin-top: 24px;
    min-width: 40px;

    &.active {
        background: #2ebd73;
    }
}

.upgrade-switching-features {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.upgrade-switching-feature {
    background-color: #f5fbf5;
    border-radius: 30px;
    width: 350px;
    height: 60px;
    display: flex;
    align-items: center;
    gap: 10px;

    img {
        width: 32px;
        height: 32px;
        margin-left: 67px;
    }

    span {
        color: #2ebd73;
        font-size: 22px;
        font-family: MicrosoftYaHei, 'Microsoft YaHei', sans-serif;
        white-space: nowrap;
        line-height: 36px;
    }
}

.upgrade-switching-bottom {
    width: 100%;
    display: block;
}

// ====== Phase 3: 感谢陪伴弹窗 ======
.upgrade-modal-thanks {
    flex-direction: column;
    width: 892px;
    height: 435px;
    padding: 0;
    border-radius: 30px;
}

.upgrade-thanks-top {
    display: flex;
    width: 862px;
    margin: 21px 0 0 30px;
}

.upgrade-thanks-left {
    display: flex;
    width: 496px;
    margin-top: 7px;
}

.upgrade-thanks-icon {
    flex-shrink: 0;
    width: 143px;
    height: 124px;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}

.upgrade-thanks-info {
    width: 326px;
    margin-top: 16px;
    margin-left: 16px;
    display: flex;
    flex-direction: column;
}

.upgrade-thanks-title {
    font-size: 36px;
    font-weight: 700;
    font-family: MicrosoftYaHei-Bold, 'Microsoft YaHei', sans-serif;
    color: #38383a;
    line-height: 36px;
    white-space: nowrap;
}

.thanks-green {
    color: #2ebd73;
    font-size: 36px;
}

.upgrade-thanks-desc {
    color: #666;
    font-size: 19px;
    font-family: MicrosoftYaHei, 'Microsoft YaHei', sans-serif;
    line-height: 36px;
    margin-top: 14px;
}

.upgrade-thanks-right-img {
    width: 372px;
    height: 309px;
    margin-left: -6px;
    flex-shrink: 0;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}

.upgrade-thanks-tip-bar {
    background: linear-gradient(120deg, #ECFFF2, #EFFFE9);
    border-radius: 40px;
    width: 403px;
    height: 80px;
    margin: 20px 0 0 57px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.upgrade-thanks-tip-icon {
    font-size: 36px;
    color: #19BD6C;
    margin-right: 10px
}

.upgrade-thanks-tip-dot {
    position: absolute;
    left: 42px;
    top: 39px;
    width: 21px;
    height: 21px;
    background-color: rgba(191, 247, 190, 0.47);
    border-radius: 50%;
}

.upgrade-thanks-tip-text {
    display: flex;
    align-items: center;
    gap: 11px;

    span {
        color: #666;
        font-size: 22px;
        font-family: MicrosoftYaHei, 'Microsoft YaHei', sans-serif;
        white-space: nowrap;
        line-height: 36px;
    }

    img {
        width: 36px;
        height: 39px;
    }
}

.upgrade-thanks-btn {
    background-color: #19bd6c;
    border-radius: 35px;
    height: 70px;
    width: 768px;
    margin: 0 0 35px 63px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #15a35e;
    }

    &:active {
        transform: scale(0.98);
    }

    span {
        color: #fff;
        font-size: 24px;
        font-family: MicrosoftYaHei, 'Microsoft YaHei', sans-serif;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/UpgradeModal/app.vue